module.exports = __webpack_public_path__ + "static/media/FeedTime_web_1.8a2f6f5c.jpg";